import apiPublic from '@/api/public.js';
export default {
  data() {
    return {
      d_img_visible: false,
      d_img_name:'',
    }
  },
  computed:{

  },
  methods: {
    file_format_error(file){
      this.$Message.error('上传失败，格式不正确!');
    },
    img_preview(file){
      let fileName = '';
      if(file.response){
        fileName = file.response.Data;
      }else {
        fileName = file.url;
      }
      let fileNameFormate = (file.name).split('.')[1];
      let _this = this;
      const downLoadingMsg = this.$Message.loading({
        content: '文件下载中，请稍等……',
        duration: 0
      });

      apiPublic.downLoadFile(fileName).then((_data) => {
        setTimeout(downLoadingMsg,100) //最聪明，没有之一 点赞
        if(_data.status===200){
          if(fileNameFormate==='png' || fileNameFormate==='jpg' || fileNameFormate==='jpeg' || fileNameFormate==='bmp'){
            _this.d_img_visible = true;
            _this.d_img_name = URL.createObjectURL(_data.data);
          }else {
            _this.downFileAll(file.name,_data.data);
          }
        }
      });
    },
    downFileAll(_name,_data){
      let blob = _data;
      let reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = function (e) {
        let a = document.createElement('a');
        a.download = _name;
        a.href = e.target.result;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    cancel_preview(){
      window.URL.revokeObjectURL(this.d_img_name);
    },
  },
  created() {

  },
  mounted() {

  }
}
